/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum LookupResultType {
  Linear = "Linear",
  Shipment = "Shipment",
  Company = "Company",
  CarrierDocument = "CarrierDocument",
  PotentialCompany = "PotentialCompany",
  Carrier = "Carrier",
  PublicApiRequest = "PublicApiRequest",
}

export function instanceOfLookupResultType(value: any): boolean {
  for (const key in LookupResultType) {
    if (Object.prototype.hasOwnProperty.call(LookupResultType, key)) {
      if (LookupResultType[key as keyof typeof LookupResultType] === value) {
        return true;
      }
    }
  }
  return false;
}

export function LookupResultTypeFromJSON(json: any): LookupResultType {
  return LookupResultTypeFromJSONTyped(json, false);
}

export function LookupResultTypeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LookupResultType {
  return json as LookupResultType;
}

export function LookupResultTypeToJSON(value?: LookupResultType | null): any {
  return value as any;
}

export function LookupResultTypeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): LookupResultType {
  return value as LookupResultType;
}
